<template>
    <div id="trial-alert" class="position-relative" v-if="!hiddenAlert">
        <div>
            <div 
                class="background-white trial-alert d-flex justify-content-between align-items-center">
                <div class="d-flex h-100">
                    <div class="icon-holder d-flex justify-content-center align-items-center">
                        <Icon icon ='warning-sign' />
                    </div>
                    <div class="pl-3 py-2">
                            <p class="p2b mb-1">You’re currently on Basic plan.</p>
                            <p class="p1n m-0">Want to get featured and have advanced tracking?</p>
                    </div>
                </div>
                <div class="d-flex h-100">
                    <router-link
                        to="/pricing" 
                        style="padding: 2px 8px" 
                        class="btn btn-purple tlabb mr-3"
                        @click.native="toPricing">
                        Upgrade Now
                    </router-link>
                    <button @click="hideAlert" class="close-icon ml-0 p-0">
                        <Icon width="20" icon="close"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from './Icon'
import moment from 'moment'
import {onMounted, ref, watch} from '@vue/composition-api'

export default {
    name: 'Alert',
    props: ['onHiddenChange'],
    components: {
        Icon
    },
    setup(props, {root}){
        const hiddenAlert = ref(false)
        const updateShowTime = () => {
            const basicPlanAlert = {
                showedTime: Date.now()
            }
            localStorage.setItem('basicPlanAlert', JSON.stringify(basicPlanAlert))
        }
        const showAlert = () => {
            const basicPlanAlert = JSON.parse(localStorage.getItem('basicPlanAlert'))

            if(basicPlanAlert && Math.abs(moment().diff(moment(basicPlanAlert.showedTime), 'hours')) < 24) {
                return hiddenAlert.value = true
            }
            
            hiddenAlert.value = false
        }
        const hideAlert = () => { 
            root.$sendMixpanelEvent('Hide Basic Plan Alert')
            root.$ga.event('Basic Plan Alert', 'Hide Basic Plan Alert')
            updateShowTime()
            hiddenAlert.value = true
        }

        watch(hiddenAlert, hiddenAlert => {
           props.onHiddenChange(hiddenAlert)
        }, {immediate: true})

        onMounted(() => {
            showAlert()
        })
        return {
            showAlert,
            hideAlert,
            hiddenAlert
        }
    }
}
</script>

<style scoped lang="scss">
    @import '../../assets/scss/variables';

    @media (max-width: 1300px) and (min-width: 992px) {
        div.alert-holder {
            margin-left: 48px;
        }
    }

    .background-white {
        background: #FFFFFF;
    }

    .trial-alert {
        border: 3px solid;
        border-left: none;
        min-height: 64px;
        border-color: #FFBC00;
        .icon-holder {
            width: 54px;
            background-color: #FFBC00;
        }
    }

    .close-icon {
        margin-right: 20px;
    }
</style>